module.exports = ".subcat-title {\n  font-weight: 600; }\n\n.goToTopBtn {\n  position: fixed;\n  bottom: 5px;\n  right: 5px;\n  z-index: 10; }\n"